import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "relative isolate min-h-screen bg-gray-900",
  id: "Contact"
}
const _hoisted_2 = { class: "mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2" }
const _hoisted_3 = { class: "relative px-6 pb-20 pt-24 sm:pt-32 lg:static lg:px-8 lg:py-48" }
const _hoisted_4 = { class: "mx-auto max-w-xl lg:mx-0 lg:max-w-lg" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"absolute inset-y-0 left-0 -z-10 w-full overflow-hidden ring-1 ring-white/5 lg:w-1/2\"><svg class=\"absolute inset-0 h-full w-full stroke-gray-700 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]\" aria-hidden=\"true\"><defs><pattern id=\"54f88622-e7f8-4f1d-aaf9-c2f5e46dd1f2\" width=\"200\" height=\"200\" x=\"100%\" y=\"-1\" patternUnits=\"userSpaceOnUse\"><path d=\"M130 200V.5M.5 .5H200\" fill=\"none\"></path></pattern></defs><svg x=\"100%\" y=\"-1\" class=\"overflow-visible fill-gray-800/20\"><path d=\"M-470.5 0h201v201h-201Z\" stroke-width=\"0\"></path></svg><rect width=\"100%\" height=\"100%\" stroke-width=\"0\" fill=\"url(#54f88622-e7f8-4f1d-aaf9-c2f5e46dd1f2)\"></rect></svg><div class=\"absolute -left-56 top-[calc(100%-13rem)] transform-gpu blur-3xl lg:left-[max(-14rem,calc(100%-59rem))] lg:top-[calc(50%-7rem)]\" aria-hidden=\"true\"><div class=\"aspect-[1155/678] w-[72.1875rem] bg-gradient-to-br from-[#80caff] to-[#4f46e5] opacity-20\" style=\"clip-path:polygon(74.1% 56.1%, 100% 38.6%, 97.5% 73.3%, 85.5% 100%, 80.7% 98.2%, 72.5% 67.7%, 60.2% 37.8%, 52.4% 32.2%, 47.5% 41.9%, 45.2% 65.8%, 27.5% 23.5%, 0.1% 35.4%, 17.9% 0.1%, 27.6% 23.5%, 76.1% 2.6%, 74.1% 56.1%);\"></div></div></div><h2 class=\"text-3xl font-bold tracking-tight text-white\">Get in touch</h2>", 2)
const _hoisted_7 = { class: "mt-10 space-y-4 text-base leading-7 text-gray-300" }
const _hoisted_8 = { class: "flex text-2xl gap-x-4" }
const _hoisted_9 = { class: "flex-none" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Address", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createTextVNode("821 S Williams St"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Westmont, IL 60559")
], -1)
const _hoisted_12 = { class: "flex text-2xl gap-x-4" }
const _hoisted_13 = { class: "flex-none" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Telephone", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "hover:text-white",
    href: "tel:+1 (224) 413-4367"
  }, "+1 (224) 413-4367")
], -1)
const _hoisted_16 = { class: "flex text-2xl gap-x-4" }
const _hoisted_17 = { class: "flex-none" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Email", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("dd", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "hover:text-white",
    href: "mailto:nixxdetailing@gmail.com"
  }, "nixxdetailing@gmail.com")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("form", {
  action: "#",
  method: "POST",
  class: "px-6 pb-24 pt-20 sm:pb-32 lg:px-8 lg:py-48"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "mx-auto max-w-xl lg:mr-0 lg:max-w-lg" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2" }, [
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("label", {
          for: "first-name",
          class: "block text-sm font-semibold leading-6 text-white"
        }, "First name"),
        /*#__PURE__*/_createElementVNode("div", { class: "mt-2.5" }, [
          /*#__PURE__*/_createElementVNode("input", {
            type: "text",
            name: "first-name",
            id: "first-name",
            autocomplete: "given-name",
            class: "block w-full rounded-md border-0 bg-white/5 px-3.5 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("label", {
          for: "last-name",
          class: "block text-sm font-semibold leading-6 text-white"
        }, "Last name"),
        /*#__PURE__*/_createElementVNode("div", { class: "mt-2.5" }, [
          /*#__PURE__*/_createElementVNode("input", {
            type: "text",
            name: "last-name",
            id: "last-name",
            autocomplete: "family-name",
            class: "block w-full rounded-md border-0 bg-white/5 px-3.5 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-2" }, [
        /*#__PURE__*/_createElementVNode("label", {
          for: "email",
          class: "block text-sm font-semibold leading-6 text-white"
        }, "Email"),
        /*#__PURE__*/_createElementVNode("div", { class: "mt-2.5" }, [
          /*#__PURE__*/_createElementVNode("input", {
            type: "email",
            name: "email",
            id: "email",
            autocomplete: "email",
            class: "block w-full rounded-md border-0 bg-white/5 px-3.5 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-2" }, [
        /*#__PURE__*/_createElementVNode("label", {
          for: "phone-number",
          class: "block text-sm font-semibold leading-6 text-white"
        }, "Phone number"),
        /*#__PURE__*/_createElementVNode("div", { class: "mt-2.5" }, [
          /*#__PURE__*/_createElementVNode("input", {
            type: "tel",
            name: "phone-number",
            id: "phone-number",
            autocomplete: "tel",
            class: "block w-full rounded-md border-0 bg-white/5 px-3.5 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-2" }, [
        /*#__PURE__*/_createElementVNode("label", {
          for: "message",
          class: "block text-sm font-semibold leading-6 text-white"
        }, "Message"),
        /*#__PURE__*/_createElementVNode("div", { class: "mt-2.5" }, [
          /*#__PURE__*/_createElementVNode("textarea", {
            name: "message",
            id: "message",
            rows: "4",
            class: "block w-full rounded-md border-0 bg-white/5 px-3.5 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
          })
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "mt-8 flex justify-end" }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "submit",
        class: "rounded-md bg-indigo-500 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
      }, "Send message")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BuildingOffice2Icon = _resolveComponent("BuildingOffice2Icon")!
  const _component_PhoneIcon = _resolveComponent("PhoneIcon")!
  const _component_EnvelopeIcon = _resolveComponent("EnvelopeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("dl", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("dt", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_BuildingOffice2Icon, {
                  class: "h-7 w-6 text-gray-400",
                  "aria-hidden": "true"
                })
              ]),
              _hoisted_11
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("dt", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_PhoneIcon, {
                  class: "h-7 w-6 text-gray-400",
                  "aria-hidden": "true"
                })
              ]),
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("dt", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_EnvelopeIcon, {
                  class: "h-7 w-6 text-gray-400",
                  "aria-hidden": "true"
                })
              ]),
              _hoisted_19
            ])
          ])
        ])
      ]),
      _hoisted_20
    ])
  ]))
}